import { TemplateElement, html, defineElement, i18n } from '@webtides/element-js';
import { unsafeHTML } from 'lit-html/directives/unsafe-html';
import { PAGE_CHANGE } from './paging-element-events';

import styles from './paging-element.css';

class PagingElement extends TemplateElement {
    constructor() {
        super({ styles: [styles] });
    }

    properties() {
        return {
            currentPage: 0,
            pages: 1,
            total: 0,
            labelPrev: i18n('pagingElement.cta.prev', 'Zurück'),
            labelNext: i18n('pagingElement.cta.next', 'Weiter'),
            labelPage: i18n('pagingElement.page.label', 'Seite'),
            disabled: false,
            containerStyling: 'text-center flex items-center space-between p-3 bg-grey-50 rounded',
            buttonPrevStyling: 'btn btn-dark',
            buttonNextStyling: 'btn btn-dark',
        };
    }

    events() {
        return {
            '[ref=prev]': {
                click: () => {
                    this.setCurrentPage(Math.max(this.currentPage - 1, 0));
                },
            },
            '[ref=next]': {
                click: () => {
                    this.setCurrentPage(Math.min(this.currentPage + 1, this.pages));
                },
            },
            '[ref=inputPage]': {
                change: ev => {
                    this.setCurrentPage(ev.currentTarget.value - 1);
                },
            },
        };
    }

    setCurrentPage(currentPage) {
        this.currentPage = currentPage;
        this.dispatch(PAGE_CHANGE, this.currentPage, true);
    }

    isPrevDisabled() {
        return this.currentPage === 0;
    }

    isNextDisabled() {
        return this.currentPage === this.pages - 1;
    }

    templateInput() {
        return `
            <select ref="inputPage" class="border border-grey-200 pl-3 pr-2 p-1 rounded-sm font-bold text-base">
                ${Array(this.pages)
                    .fill(0)
                    .map((_, page) => {
                        return `<option ${page === this.currentPage ? 'selected' : ''}>${page + 1}</option> `;
                    })
                    .join('')}
            </select>
        `;
    }

    template() {
        if (this.disabled || this.total === 0) {
            return null;
        }
        return html`<div class="${this.containerStyling}">
            <button ref="prev" class="${this.buttonPrevStyling}" ?disabled="${this.isPrevDisabled()}">
                <svg-icon name="chevron-left"></svg-icon>
                <span class="text-sm sm:text-base">${this.labelPrev}</span>
            </button>

            <div class="flex flex-1 justify-center">
                <div class="flex items-center space-x-2 hidden md:block">
                    <span class="text-grey-400 inline-block">${this.labelPage}:</span>
                    <span class="inline-flex items-center space-x-4 font-bold"
                        >${unsafeHTML(this.templateInput())} <span>/</span> <span>${this.pages}</span></span
                    >
                </div>
            </div>

            <button ref="next" class="${this.buttonNextStyling}" ?disabled="${this.isNextDisabled()}">
                <span class="text-sm sm:text-base">${this.labelNext}</span>
                <svg-icon name="chevron-right"></svg-icon>
            </button>
        </div>`;
    }
}

defineElement('paging-element', PagingElement);
